export default __webpack_public_path__ + "static/media/7.389d5e94.jpg";